import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad betyder PBI?";
const SHORT_ANSWER = "PBI står för 'Personer med Betydande Inflytande' – de som har sådan ställning i bolaget att de prövas för lämplighet vid serveringstillstånd.";

export const Route = createFileRoute("/fraga/vad-betyder-pbi")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad betyder PBI" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Begreppet kommer från alkohollagens praxis och Folkhälsomyndighetens vägledning. PBI används också inom spelregleringen och delvis i bank/finansprövning."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "PBI-kretsen – komplett förklaring" }}
      related={[{"to": "/fraga/vilka-rakas-till-pbi-kretsen", "label": "Vilka räknas till PBI-kretsen?"}, {"to": "/fraga/vad-galler-for-finansierare-av-verksamhet", "label": "Räknas finansiärer in i PBI-kretsen?"}, {"to": "/fraga/kan-jag-trana-gratis", "label": "Kan jag träna på kunskapsprovet gratis?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad betyder PBI?" },
      { name: "description", content: "PBI står för 'Personer med Betydande Inflytande' – de som har sådan ställning i bolaget att de prövas för lämplighet vid serveringstillstånd." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-betyder-pbi" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-betyder-pbi" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-betyder-pbi",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad betyder PBI", url: "https://alkoholprovet.se/fraga/vad-betyder-pbi" },
      ]),
    ],
  }),
});
